import { render, staticRenderFns } from "./QuickStock.vue?vue&type=template&id=6430969c&scoped=true"
import script from "./QuickStock.vue?vue&type=script&lang=js"
export * from "./QuickStock.vue?vue&type=script&lang=js"
import style0 from "./QuickStock.vue?vue&type=style&index=0&id=6430969c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6430969c",
  null
  
)

export default component.exports